import React from "react"
import Layout from "../components/layout"
import ContactForm from "../components/contact-form"
import Seo from "../components/seo"

export default function ContactPage() {
  return (
    <Layout sb={false}>
       <Seo title="Contact Us"  description={"Contact Nightnightystories.com with any comments or concenrs about our content."}/>
      <div>
        <header className="bg-white dark:bg-gray-900 dark:text-white ">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-12">
            Contact
          </h1>
        </header>
        <div>
          <p className={'font-bold mb-2'}>
             Got something on your mind?
          </p>
          <p className={'mb-8'}>
            We are easy going and open to any thoughts or criticisms our reader
            might have. Send us a message with the form below and we will get back you as soon
            as possible.
          </p>
        </div>
        <div>
          <ContactForm />
        </div>
      </div>
    </Layout>
  )
}
